// Κανόνες ανάλυσης συστατικών (INCI) για καλλυντικά, είδη περιποίησης και καθαριστικά.
// Το σκορ υπολογίζεται ΜΟΝΟ με σταθερούς κανόνες, ώστε να είναι συνεπές και εξηγήσιμο.

export type RiskLevel = "high" | "medium" | "low";

export type FlaggedIngredient = {
  key: string;
  name: string;
  level: RiskLevel;
  why: string;
  matched: string;
};

type Rule = { key: string; name: string; level: RiskLevel; why: string; test: RegExp };

const RULES: Rule[] = [
  { key: "aluminium", name: "Άλατα αλουμινίου", level: "medium", why: "Αντιιδρωτικός παράγοντας· αμφιλεγόμενος για καθημερινή χρήση στις μασχάλες, υπό διερεύνηση για πιθανές επιπτώσεις.", test: /alumin(?:i)?um (?:chlorohydrate|sesquichlorohydrate|zirconium|chloride|sulfate|chlorohydrex)|\balum\b|potassium alum|αλουμιν/ },
  { key: "parabens", name: "Parabens (προπυλ-/βουτυλ-)", level: "high", why: "Συντηρητικά με πιθανή δράση ενδοκρινικού διαταράκτη.", test: /(propyl|butyl|isobutyl|isopropyl)paraben/ },
  { key: "parabens_light", name: "Parabens (μεθυλ-/αιθυλ-)", level: "low", why: "Συντηρητικά χαμηλότερου κινδύνου, αλλά πολλοί προτιμούν να τα αποφεύγουν.", test: /(methyl|ethyl)paraben/ },
  { key: "triclosan", name: "Triclosan / Triclocarban", level: "high", why: "Αντιβακτηριδιακό με πιθανή ενδοκρινική δράση και επιβάρυνση του περιβάλλοντος.", test: /triclosan|triclocarban/ },
  { key: "formaldehyde", name: "Απελευθερωτές φορμαλδεΰδης", level: "high", why: "Απελευθερώνουν φορμαλδεΰδη, γνωστό αλλεργιογόνο και ερεθιστικό.", test: /formaldehyde|dmdm hydantoin|imidazolidinyl urea|diazolidinyl urea|quaternium-15|bronopol|2-bromo-2-nitropropane|sodium hydroxymethylglycinate|methenamine/ },
  { key: "mit", name: "Methylisothiazolinone (MIT/MCI)", level: "high", why: "Συντηρητικό με υψηλό ποσοστό αλλεργικών αντιδράσεων στο δέρμα.", test: /methylisothiazolinone|methylchloroisothiazolinone|benzisothiazolinone|octylisothiazolinone/ },
  { key: "phthalates", name: "Φθαλικές ενώσεις", level: "high", why: "Πιθανοί ενδοκρινικοί διαταράκτες.", test: /phthalate/ },
  { key: "bht", name: "BHA / BHT", level: "medium", why: "Συνθετικά αντιοξειδωτικά υπό αξιολόγηση για πιθανές επιπτώσεις.", test: /\bbha\b|\bbht\b|butylated hydroxy(anisole|toluene)/ },
  { key: "uv_filters", name: "Αμφιλεγόμενα φίλτρα UV", level: "medium", why: "Χημικά φίλτρα (π.χ. oxybenzone) με πιθανή ενδοκρινική δράση.", test: /benzophenone-3|oxybenzone|ethylhexyl methoxycinnamate|octinoxate|homosalate|4-methylbenzylidene camphor|octocrylene/ },
  { key: "sls", name: "Sodium Lauryl Sulfate (SLS)", level: "medium", why: "Ισχυρό επιφανειοδραστικό που μπορεί να ερεθίσει ή να ξηράνει το δέρμα.", test: /sodium lauryl sulfate|ammonium lauryl sulfate/ },
  { key: "sles", name: "Sodium Laureth Sulfate (SLES)", level: "low", why: "Πιο ήπιο από το SLS αλλά μπορεί να ερεθίσει ευαίσθητες επιδερμίδες.", test: /laureth sulfate/ },
  { key: "peg", name: "PEG / Αιθοξυλιωμένα", level: "low", why: "Μπορεί να περιέχουν υπολείμματα από τη διαδικασία παραγωγής.", test: /\bpeg-\d|\bppg-\d|ceteareth|steareth/ },
  { key: "silicones", name: "Σιλικόνες (κυκλικές)", level: "medium", why: "Κυκλικές σιλικόνες (D4/D5/D6) βιοσυσσωρεύονται στο περιβάλλον.", test: /cyclopentasiloxane|cyclotetrasiloxane|cyclohexasiloxane|cyclomethicone/ },
  { key: "fragrance_allergens", name: "Αλλεργιογόνα αρωμάτων", level: "low", why: "Συστατικά αρωμάτων που πρέπει να δηλώνονται ως πιθανά αλλεργιογόνα.", test: /limonene|linalool|citronellol|geraniol|coumarin|eugenol|hexyl cinnamal|benzyl salicylate|citral|alpha-isomethyl ionone|butylphenyl methylpropional|lilial|hydroxycitronellal/ },
  { key: "microplastics", name: "Μικροπλαστικά", level: "medium", why: "Πολυμερή που επιβαρύνουν το περιβάλλον.", test: /polyethylene(?! glycol)|polypropylene(?! glycol)|nylon-12|acrylates copolymer|polymethyl methacrylate/ },
  { key: "mineral_oil", name: "Ορυκτά έλαια", level: "low", why: "Παράγωγα πετρελαίου· μπορεί να φράζουν τους πόρους.", test: /paraffinum liquidum|mineral oil|petrolatum/ },
  { key: "ethanolamines", name: "Αιθανολαμίνες (DEA/TEA)", level: "medium", why: "Μπορεί να σχηματίσουν νιτροζαμίνες.", test: /diethanolamine|triethanolamine|monoethanolamine|cocamide dea|cocamide mea|\b(?:dea|tea|mea)-/ },
  { key: "chlorine", name: "Χλώριο / Υποχλωριώδες", level: "medium", why: "Ισχυρό οξειδωτικό, ερεθιστικό για δέρμα και αναπνοή.", test: /sodium hypochlorite|υποχλωρ/ },
  { key: "phosphates", name: "Φωσφορικά", level: "low", why: "Επιβαρύνουν τα νερά (ευτροφισμός).", test: /phosphate\b|φωσφορικ/ },
];

export type IngredientTag = { key: string; label: string; emoji: string };

export const INGREDIENT_TAGS: IngredientTag[] = [
  { key: "no_aluminium", label: "Χωρίς αλουμίνιο", emoji: "🧪" },
  { key: "no_parabens", label: "Χωρίς parabens", emoji: "🚫" },
  { key: "no_sulfates", label: "Χωρίς θειικά (SLS)", emoji: "🫧" },
  { key: "no_alcohol", label: "Χωρίς οινόπνευμα", emoji: "🍃" },
  { key: "no_fragrance", label: "Χωρίς άρωμα", emoji: "🌬️" },
  { key: "no_silicones", label: "Χωρίς σιλικόνες", emoji: "💧" },
];

export const INGREDIENT_TAG_LABEL: Record<string, string> = Object.fromEntries(
  INGREDIENT_TAGS.map((t) => [t.key, t.label]),
);

const PENALTY: Record<RiskLevel, number> = { high: 25, medium: 12, low: 4 };

function norm(s: string): string {
  return s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function analyzeIngredients(text: string): { score: number; flagged: FlaggedIngredient[]; tags: string[] } {
  const s = norm(text);
  const flagged: FlaggedIngredient[] = [];
  for (const r of RULES) {
    const m = s.match(r.test);
    if (m) flagged.push({ key: r.key, name: r.name, level: r.level, why: r.why, matched: m[0] });
  }
  let score = 100;
  let lowCount = 0;
  for (const f of flagged) {
    if (f.level === "low") {
      lowCount++;
      if (lowCount > 3) continue; // πλαφόν στα «ελαφριά»
    }
    score -= PENALTY[f.level];
  }
  const highs = flagged.filter((f) => f.level === "high").length;
  if (highs >= 2) score -= 10;
  score = Math.max(5, Math.min(100, score));

  const has = (k: string) => flagged.some((f) => f.key === k);
  const tags: string[] = [];
  if (!has("aluminium")) tags.push("no_aluminium");
  if (!has("parabens") && !has("parabens_light")) tags.push("no_parabens");
  if (!has("sls") && !has("sles") && !/sulfate/.test(s)) tags.push("no_sulfates");
  if (!/alcohol denat|\bethanol\b|\balcohol\b(?! ?(cetyl|cetearyl|stearyl|benzyl))/.test(s.replace(/(cetyl|cetearyl|stearyl|benzyl|behenyl|myristyl) alcohol/g, ""))) tags.push("no_alcohol");
  if (!/parfum|fragrance|aroma\b/.test(s) && !has("fragrance_allergens")) tags.push("no_fragrance");
  if (!/(methicone|siloxane|dimethiconol)/.test(s)) tags.push("no_silicones");
  // Order by severity
  const order: RiskLevel[] = ["high", "medium", "low"];
  flagged.sort((a, b) => order.indexOf(a.level) - order.indexOf(b.level));
  return { score, flagged, tags };
}

export const RISK_LABEL: Record<RiskLevel, string> = { high: "Υψηλός", medium: "Μέτριος", low: "Χαμηλός" };

export const INGREDIENT_FILTERS = [
  { key: "great", label: "🧴 Εξαιρετικά συστατικά (80+)", min: 80 },
  { key: "good", label: "🌿 Καλά συστατικά (60+)", min: 60 },
] as const;

export function ingredientFilterMin(key: string | undefined): number | undefined {
  return INGREDIENT_FILTERS.find((f) => f.key === key)?.min;
}
